import React, { useState } from 'react';
import IntroAnimation from '../components/IntroAnimation';
import PillNav from '../components/PillNav';
import Hero from '../components/Hero';
import About from '../components/About';
import HowWeWork from '../components/HowWeWork';
import Skills from '../components/Skills';
import Projects from '../components/Projects';
import CurvedLoop from '../components/CurvedLoop';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  const [showIntro, setShowIntro] = useState(true);

  const handleIntroComplete = () => {
    setShowIntro(false);
  };

  const navItems = [
    { id: 'about', label: 'About' },
    { id: 'how-we-work', label: 'Process' },
    { id: 'skills', label: 'Services' },
    { id: 'projects', label: 'Work' }
  ];

  const handleCTAClick = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="home-container">
      {showIntro && <IntroAnimation onComplete={handleIntroComplete} />}
      
      {!showIntro && (
        <>
          <PillNav 
            items={navItems}
            onCTAClick={handleCTAClick}
          />
          <Hero />
          <About />
          <CurvedLoop 
            marqueeText="CREATIVE DESIGN • WEB DEVELOPMENT • AI POWERED • VISUAL STORYTELLING • "
            speed={1.5}
            curveAmount={300}
            className="curved-text-style"
          />
          <HowWeWork />
          <Skills />
          <Projects />
          <Contact />
          <Footer />
        </>
      )}
    </div>
  );
};

export default Home;
